<template>
	
  <div style="width: 100%;">
	  <el-header height="12vh" style="padding: 0;">
	    <div  style="background-color: #ffffff; width: 100%; display: flex;align-items: center;">
	  	  <div style="height: 100%;display: flex;align-items: center;width: 100%;">
	  		  <img style="height: 100%;width: 50%;margin-left: 10%;" src="../assets/logo.png"/>
	  	  </div>
	  	  
	  	  <!-- <div @click="show3 = !show3" style=" background-color: #0d0833;position: absolute;right: 5%;" >
	  	      <i class="el-icon-arrow-down el-icon--right" ></i>
	  	  </div>  -->
	  	  <div @click="toggleMenu" class="banner_menu" :class="{ changeFigure: show3 }">
	  	            <s></s>
	  	            <s></s>
	  	            <s></s>
	  	  </div>
		  
	  	  
	      
	    </div>
	     
	  </el-header>
	  <el-main>
		  <div style="margin-top: 20px; height: auto;width: 100%;">
		        <el-collapse-transition>
		          <div v-show="show3">
		            <div class="transition-box" style="color: #a5d4ce;" >Home</div>
		            <div class="transition-box" >Brand Sources</div>
		            <div class="transition-box" >Medical News</div>
		            <div class="transition-box" >Product Center</div>
		            <div class="transition-box" >Product Validation</div>
		            <div class="transition-box" >Testimonials</div>
		            <div class="transition-box" >Contact Us</div>
		          </div>
		  
		        </el-collapse-transition>
		    </div>
    <!-- 轮播 -->
	<div id="app">
		<el-carousel :interval="4000" type="default" height="18vh" style="width: 100%;border-radius: 10px;" indicator-position="none" ref="carousel" arrow="never">
			  <el-carousel-item v-for="(item, index) in items" :key="index">
				  <img style="height: 100%; width: 100%;" :src="item"  />
			  </el-carousel-item>
		  </el-carousel>
	</div>



    <div style="display: flex; width: 100%; height: 16vw; flex-direction: column;margin-top: 2vw;">
      <div style="display: flex; width: 90%; font-size: 7vw; color: #fb0065; font-weight: 700; align-items: center; margin-left: 2vw;">
        Code Query
      </div>
      <div style="background-color: #038875; border-radius: 10px; width: 8vw; height: 1.7vw; margin-left: 2vw; margin-top: 2vw;"></div>
    </div>

    <div style="display: flex; flex-direction: column; height: auto; width: 100%; ">
      <div style="width: 100%; ">
        <input class="name"  v-model="input" :class="inputClass"/>
        <button @click="toggleStatus" v-if="isActive"  class="query-button">
          query
        </button>
      </div>
	  
	  <div :style="{ color: messageType === 'success' ? '#278815' : messageType === 'warning' ? '#a5833f' : 'red' }">
	    {{ tostring }}
	  </div>

    </div>
	
	
	
	<button @click="verifyProduct" v-if="!isActive"  class="query-button" style="margin-left: 5vw;margin-bottom: 3vh;">
	  query
	</button>

    <div style="display: flex; width: 100%; flex-direction: column;">
      <div style="display: flex; width: 90%; font-size: 7vw; color: #fb0065; font-weight: 700; align-items: center; margin-left: 2vw;">
        Query Method
      </div>
      <div style="background-color: #038875; border-radius: 10px; width: 8vw; height: 1.7vw; margin-left: 2vw; margin-top: 2vw;"></div>

      <span style="font-size: 3.5vw; margin-left: 2vw; line-height: 6vw; margin-top: 5vw;color: #777777;">
        Scanning the two-dimensional code on the VIP card or manually inputting the 12-digit numbers to validate the product.

      </span>
    </div>

    <div style="display: flex; width: 100%; flex-direction: column; margin-top: 2vw;">
      <div style="display: flex; width: 90%; font-size: 7vw; color: #fb0065; font-weight: 700; align-items: center; margin-left: 2vw;">
        Reminder
      </div>
      <div style="background-color: #038875; border-radius: 10px; width: 8vw; height: 1.7vw; margin-left: 2vw; margin-top: 2vw;"></div>

      <span style="font-size: 3.5vw; margin-left: 2vw; line-height: 6vw; margin-top: 5vw;color: #777777;">
        In order to ensure the authenticity and reliability of anti-counterfeiting queries, each security code can only valid for one time, continuously input of same security code will show the code has been used.
      </span>
    </div>
	
	<div  style="display: flex;align-items: center;justify-content: center;width: 100%;height: 15vh;	">
		<div style="width: 48%;height: 3.2vh;font-size: 3vw;color: #029680;background-color: #e8e8e8;display: flex;align-items: center;justify-content: center;border-radius: 2px;font-weight: 500;border-radius: 10px;">Click on the official website</div>
	</div>
	<div style="width: 100%;height: 4vh;"></div>
	  </el-main>
  </div>

</template>

<script>
import ElementUI from 'element-ui';
export default {
	
  data() {
    return {
      items: [
        require('@/assets/slider-rev1.jpg'),
        require('@/assets/slider-rev2.jpg'),
        require('@/assets/slider-rev3.jpg'),
        require('@/assets/slider-rev4.jpg')
      ],
	  isActive:true,
	  input:'',
	  tostring:"",
	  show3: false,
	  messageType: 'error',
    };
  },
  computed: {
    inputClass() {
		if(this.isActive){
			return
		}
		if(!this.input.length){
			this.tostring = "This value is required.";
			return
		}
        }
  },
 
  methods: {
	  toggleMenu() {
	        this.show3 = !this.show3;
	      },
	  checkWindowSize() {
	        if (window.innerWidth > 700) {
	          this.$router.push('/message-center');
	        }
	      },
	  // openWebsite() {
	  //       window.open('http://www.douyin.com', '_self');
	  //     },
	  verifyProduct() {
	        const inputValue = this.input.trim();
			console.log(inputValue)
	        if (!inputValue) {
	          this.tostring = "This value is required";
	          return;
	        }
	        fetch('http://www.zaguta.ph/verify_code', {
	          method: 'POST',
	          headers: { 'Content-Type': 'application/json' },
	          body: JSON.stringify({ code: inputValue })
	        })
	        .then(response => response.json())
	        .then(data => {
	          // 根据后端返回的状态显示不同的消息
	          if (data.status === 'verified') {
	            // 防伪码验证成功
				this.toString= 'Your product is genuine. Thank you for verifying!';
	            this.$message.success('Your product is genuine. Thank you for verifying!');
				this.messageType = 'success'; // 绿色
	          } else if (data.status === 'invalid') {
	            // 防伪码无效
				this.$router.push('/order-management');
	          } else if (data.status === 'already verified') {
	            // 防伪码已被验证
				this.messageType = 'warning'; // 黄色
				this.tostring = `This code was already verified on ${data.first_verified_at}. Please contact us if you have any questions.`;
	            this.$message.warning(`This code was already verified on ${data.first_verified_at}. Please contact us if you have any questions.`);
	          } else {
	            // 其他情况，可能是服务器返回了未预料的状态
				this.messageType = 'error'; // 红色
				this.toString= 'An unexpected error occurred. Please try again later.';
	            this.$message.error('An unexpected error occurred. Please try again later.');
	          }
	        })
	        .catch(error => {
	          console.error('Error verifying product:', error);
	          this.$message.error('An error occurred. Please try again later.');
	        });
	      },
	  toggleStatus() {
	        this.isActive = !this.isActive; // 切换状态
			this.verifyProduct();
	      },
      startAuto() {
        if (!this.autoplay) {
          this.autoplay = true;
        }
      },
      stopAuto() {
        if (this.autoplay) {
          this.autoplay = false;
        }
      },
      slideBanner() {
        //选中item的盒子
        var box = document.querySelector('.el-carousel__container');
        //手指起点X坐标
        var startPoint = 0;
        //手指滑动重点X坐标
        var stopPoint = 0;
  
        //重置坐标
        var resetPoint = function () {
          startPoint = 0;
          stopPoint = 0;
        };
  
        //手指按下
        box.addEventListener('touchstart', (e) => {
          //手指按下的时候停止自动轮播
          this.stopAuto();
          //手指点击位置的X坐标
          startPoint = e.changedTouches[0].pageX;
        });
        //手指滑动
        box.addEventListener('touchmove', (e) => {
          //手指滑动后终点位置X的坐标
          stopPoint = e.changedTouches[0].pageX;
        });
        //当手指抬起的时候，判断图片滚动离左右的距离
        box.addEventListener('touchend', (e) => {
          console.log('1：' + startPoint);
          console.log('2：' + stopPoint);
          if (stopPoint === 0 || startPoint - stopPoint === 0) {
            resetPoint();
            return;
          }
          if (startPoint - stopPoint > 0) {
            resetPoint();
            this.$refs.carousel.next();
            return;
          }
          if (startPoint - stopPoint < 0) {
            resetPoint();
            this.$refs.carousel.prev();
            return;
          }
        });
      },
    },
  mounted() {
	  this.checkWindowSize();
    this.slideBanner();
	window.addEventListener('resize', this.checkWindowSize);
  },
  beforeDestroy() {
	 window.removeEventListener('resize', this.resizeHandler);
  },
};
</script>

<style scoped>
	.transition-box {
	    width: 100%;
	    height: 15vw;
	    background-color: #30344d;
	    text-align: center;
	    color: #fff;
		display: flex;
	    box-sizing: border-box;
		align-items: center;
		font-size: 5vw;
		font-weight: 600;
		padding-left: 10%;
	  }
	/* banner三条横线——菜单 start */
	.banner_menu {
	  height: 7vh;
	  position: absolute;
	  right: 5%;
	  width: 9vh;
	  cursor: pointer;
	}
	.el-main {
	
	  color: #333;
	  display: flex;
	  flex-direction: column;
	  width: 100%;
	  margin: 0;
	  padding: 0;
	
	}
	.banner_menu s {
	  background-color: #000;
	  position: absolute;
	  width: 6vw;
	  height: 1vw;
	  transition: all 0.5s ease;
	  transform-origin: center;
	}
	.banner_menu s:first-child {
	  top: 0;
	}
	.banner_menu s:nth-child(2) {
	  top: 2vw;
	}
	.banner_menu s:nth-child(3) {
	  top: 4vw;
	}
	.changeFigure s:first-child {
	  transform: rotate(45deg) translate(1px);
	  top: 2vw;
	}
	.changeFigure s:nth-child(2) {
	  transform: scaleX(0);
	  opacity: 0;
	}
	.changeFigure s:nth-child(3) {
	  transform: rotate(-45deg) translate(0);
	  top: 2vw;
	}
	
button.query-button {
  padding: 8px 18px;
  color: #f7f7f7;
  background-color: #f23630;
  font-weight: 700;
  font-size: 4vw;
  border-radius: 4px;
  margin-left: 2vw;
  border: none;
  width: 22vw;
  height: 6vh;
}

button.query-button:active {
  background-color: #f4524d;
}

.name {
  margin-top: 4vw;
  width: 70vw;
  border: 1px solid #707070;
  border-radius: 3px;
  color: #6f6f6f;
  font-size: 4vw;
  text-indent: 10px;
  margin-left: 2vw;
  height: 6vh;
}
.input-valid{
	background-color: #DFF0D8;
	color: #468847;
	outline: 1px solid #D6E9C6;
	border: 1px solid #D6E9C6;
}
.input-invalid{
	background-color: #F2DEDE;
	color: #B94A48;
	outline: 1px solid #EED3D7;
	border: 1px solid #EED3D7;
}


.carouselx {
  width: 100%;
  height: 18vh;
  background-color: #475669;
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>
